import React from 'react';
import $ from 'jquery';
import GameStore from '../stores/GameStore';
import LevelActions from '../actions/LevelActions';

export default class Credits extends React.Component {

  componentDidMount() {
    this.props.sound.play('credits');
    setTimeout(function() { $('.credits').animate({ scrollTop: 1200}, 60000, "linear"); }, 10000);
  }

  render() {
    return (
      <div className="credits">
        <h1>Congratulations!! You have won!</h1>

        <p>
          Wow! Cool! Congratulations, you did it! {GameStore.texts.name} has reached its goal. The monsters have been driven out of the village, and more importantly, Lola has been saved.
        </p>
        <p>
          {GameStore.texts.name} picks up Lola and heads home. Everyone is waiting at home and gathers excitedly around {GameStore.texts.name}, wanting to know what happened. Everyone listens intently as {GameStore.texts.name} tells them about the nasty monsters, the incredible treasures, and brave Lola.
        </p>

        <p>
          After a few weeks, {GameStore.texts.name} has almost forgotten about the events when suddenly Tom, who had been missing for a long time, reappears. Tom looks shaken and very worried. In his hands he holds the charred remains of a mysterious machine...
        </p>

        <p>To be continued! Thank you for playing!</p>

        <p>
          <button onClick={this.returnToMenu}>Back to Start</button>
        </p>
      </div>
    );
  }

  returnToMenu = () => {
    this.props.sound.stop('credits');
    LevelActions.creditsShown();
  }

}